import { render, staticRenderFns } from "./vueBookingModal.vue?vue&type=template&id=3c15fea2&scoped=true&"
import script from "./vueBookingModal.vue?vue&type=script&lang=js&"
export * from "./vueBookingModal.vue?vue&type=script&lang=js&"
import style0 from "./vueBookingModal.vue?vue&type=style&index=0&id=3c15fea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c15fea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
